const useFlipper = () => {};

export default useFlipper;
